import service from '@/utils/server';

const modName='/bd/systemLog/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportData',
    method: 'post',
    data
  });
};

export const detail = data => {
  return service({
    url: modName + 'detail/' + data,
    method: 'post',
  });
};

export const listTitle = data => {
  return service({
    url: modName + 'listTitle',
    method: 'post',
  });
};



// WEBPACK FOOTER //
// ./src/page/log/systemLog/api/index.js